/** Matches ChatMessageComponent typewriter speed (5 ms per character). */
export const CHAT_CHAR_DELAY_MS = 5;

export function streamTypewriter(text, onChar, delayMs = CHAT_CHAR_DELAY_MS) {
  const content = text || "";
  return new Promise((resolve) => {
    if (!content.length) {
      resolve();
      return;
    }
    let i = 0;
    const timer = window.setInterval(() => {
      if (i < content.length && content.charAt(i)) {
        onChar(content.charAt(i));
        i += 1;
      } else {
        window.clearInterval(timer);
        resolve();
      }
    }, delayMs);
  });
}
